import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function TermosCondicoesPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const canonicalUrl = 'https://example.com/termos-condicoes';

  return (
    <>
      <div className="min-h-screen bg-white">
        {/* Navegação */}
        <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}>
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <Link to="/" className="flex items-center">
                <img 
                  src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/821bfe14b1fc609bf2a57dd541a10a42.png" 
                  alt="Logótipo FF Travel Angola - Agência de Viagens em Luanda" 
                  className="h-24 md:h-28"
                />
              </Link>
              
              <div className="hidden md:flex items-center space-x-8">
                <Link to="/" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                  Início
                </Link>
                <Link to="/agencia-viagens" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                  Agência de Viagens
                </Link>
                <Link to="/loja-servicos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                  Loja & Serviços
                </Link>
                <Link to="/sobre" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                  Sobre
                </Link>
                <Link to="/contactos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                  Contactos
                </Link>
              </div>

              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hidden md:block bg-[#ff6b35] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff5722] transition-all shadow-md whitespace-nowrap cursor-pointer"
              >
                Pedir Cotação
              </a>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="text-center text-white animate-fade-in">
              <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 animate-slide-up">
                <i className="ri-file-text-line text-xl"></i>
                <span className="text-sm font-medium">Termos Legais</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up" style={{ animationDelay: '0.1s' }}>
                Termos e Condições Gerais
              </h1>
              <p className="text-xl text-white/90 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
                Última atualização: Janeiro de 2025
              </p>
            </div>
          </div>
        </section>

        {/* Conteúdo */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="prose prose-lg max-w-none">
              
              {/* Introdução */}
              <div className="mb-12">
                <p className="text-gray-700 leading-relaxed text-lg">
                  Bem-vindo aos Termos e Condições Gerais da <strong>FF Prestação & Serviço, Lda</strong> (FF TRAVEL), com NIF 500714988, registada em Angola. Ao utilizar os nossos serviços, você concorda com os termos aqui estabelecidos, em conformidade com a legislação angolana aplicável.
                </p>
              </div>

              {/* 1. Definições */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-book-line text-[#ff6b35]"></i>
                  1. Definições
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>"Agência"</strong> refere-se à FF Prestação & Serviço, Lda (FF TRAVEL)</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>"Cliente"</strong> refere-se a qualquer pessoa que contrate os nossos serviços</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>"Serviços"</strong> incluem agência de viagens, venda de passagens, reservas de hotéis, apoio para vistos, seguros de viagem e venda de produtos eletrónicos</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>"Fornecedores"</strong> referem-se a companhias aéreas, hotéis, seguradoras e outros parceiros</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* 2. Âmbito de Aplicação */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-global-line text-[#ff6b35]"></i>
                  2. Âmbito de Aplicação
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-gray-700 mb-4">
                    Estes Termos e Condições aplicam-se a todos os serviços prestados pela FF TRAVEL, incluindo:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Pacotes turísticos personalizados</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Apoio para obtenção de vistos</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Venda de produtos eletrónicos (telemóveis, acessórios)</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* 3. Reservas e Pagamentos */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-bank-card-line text-[#ff6b35]"></i>
                  3. Reservas e Pagamentos
                </h2>
                <div className="bg-gray-50 rounded-xl p-8 space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">3.1 Processo de Reserva</h3>
                    <p className="text-gray-700 mb-3">
                      As reservas podem ser efetuadas presencialmente, por telefone, WhatsApp ou através do nosso website. Todas as reservas estão sujeitas a disponibilidade e confirmação.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">3.2 Pagamentos</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                        <span>Aceitamos pagamentos em Kwanzas (AOA) e outras moedas conforme acordado</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                        <span>Formas de pagamento: dinheiro, transferência bancária, multicaixa</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                        <span>Pode ser exigido um sinal ou pagamento total no momento da reserva</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                        <span>O pagamento completo deve ser efetuado antes da emissão dos bilhetes</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">3.3 Confirmação</h3>
                    <p className="text-gray-700">
                      Após o pagamento, será emitida uma confirmação por escrito (email, WhatsApp ou documento físico) com todos os detalhes da reserva.
                    </p>
                  </div>
                </div>
              </div>

              {/* 4. Cancelamentos e Reembolsos */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-refund-line text-[#ff6b35]"></i>
                  4. Cancelamentos e Reembolsos
                </h2>
                <div className="bg-gray-50 rounded-xl p-8 space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">4.1 Cancelamento pelo Cliente</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Os cancelamentos devem ser comunicados por escrito</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Aplicam-se as políticas de cancelamento dos fornecedores (companhias aéreas, hotéis)</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Podem ser aplicadas taxas de cancelamento conforme o prazo de antecedência</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Bilhetes não reembolsáveis não podem ser cancelados</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">4.2 Reembolsos</h3>
                    <p className="text-gray-700 mb-3">
                      Os reembolsos estão sujeitos às políticas dos fornecedores e podem demorar até 30 dias úteis após aprovação. Taxas administrativas podem ser deduzidas.
                    </p>
                  </div>

                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="text-sm text-blue-800">
                      <strong>Importante:</strong> Recomendamos a contratação de seguro de viagem com cobertura de cancelamento.
                    </p>
                  </div>
                </div>
              </div>

              {/* 5. Responsabilidades */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-shield-line text-[#ff6b35]"></i>
                  5. Responsabilidades
                </h2>
                <div className="bg-gray-50 rounded-xl p-8 space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">5.1 Responsabilidade da Agência</h3>
                    <p className="text-gray-700 mb-3">A FF TRAVEL atua como intermediária entre o cliente e os fornecedores de serviços. A nossa responsabilidade limita-se a:</p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                        <span>Processar reservas de forma correta e eficiente</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                        <span>Fornecer informações precisas sobre os serviços</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-check-line text-green-600 text-xl flex-shrink-0 mt-1"></i>
                        <span>Assistir em caso de problemas com fornecedores</span>
                      </li>
                    </ul>
                    <p className="text-gray-700 mt-3">
                      Não nos responsabilizamos por atrasos, cancelamentos ou alterações de serviços causados pelos fornecedores, condições meteorológicas, greves, pandemias ou outros eventos fora do nosso controlo.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">5.2 Responsabilidade do Cliente</h3>
                    <p className="text-gray-700 mb-3">O cliente é responsável por:</p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-3">
                        <i className="ri-user-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Fornecer informações corretas e completas</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-passport-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Garantir que possui documentos válidos (passaporte, visto, vacinas)</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-time-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Comparecer nos horários estabelecidos para voos e serviços</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-file-list-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Cumprir as regras e regulamentos dos fornecedores</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 6. Documentação de Viagem */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-passport-line text-[#ff6b35]"></i>
                  6. Documentação de Viagem
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-gray-700 mb-4">
                    É da exclusiva responsabilidade do cliente garantir que possui toda a documentação necessária para a viagem:
                  </p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Passaporte válido</strong> com validade mínima de 6 meses</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Vistos necessários</strong> para os países de destino e trânsito</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Certificados de vacinação</strong> quando exigidos</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span><strong>Autorizações especiais</strong> para menores desacompanhados</span>
                    </li>
                  </ul>
                  <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                    <p className="text-sm text-red-800">
                      <strong>Aviso:</strong> A FF TRAVEL não se responsabiliza por recusas de embarque ou entrada em países devido a documentação inadequada.
                    </p>
                  </div>
                </div>
              </div>

              {/* 7. Venda de Produtos Eletrónicos */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-smartphone-line text-[#ff6b35]"></i>
                  7. Venda de Produtos Eletrónicos
                </h2>
                <div className="bg-gray-50 rounded-xl p-8 space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">7.1 Garantia</h3>
                    <p className="text-gray-700 mb-3">
                      Todos os produtos eletrónicos vendidos pela FF MOBILE (divisão da FF TRAVEL) possuem garantia conforme especificado no momento da compra.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1e3a8a] mb-3">7.2 Trocas e Devoluções</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Produtos com defeito de fábrica podem ser trocados dentro do prazo de garantia</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>O produto deve estar em perfeitas condições, com embalagem original</span>
                      </li>
                      <li className="flex items-start gap-3">
                        <i className="ri-arrow-right-s-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                        <span>Não aceitamos devoluções por arrependimento após 7 dias da compra</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* 8. Proteção de Dados */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-lock-line text-[#ff6b35]"></i>
                  8. Proteção de Dados Pessoais
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-gray-700 mb-4">
                    A FF TRAVEL compromete-se a proteger os dados pessoais dos clientes em conformidade com a Lei de Proteção de Dados de Angola. Para mais informações, consulte a nossa{' '}
                    <Link to="/politicas-privacidade" className="text-[#1e40af] hover:text-[#ff6b35] font-semibold underline">
                      Política de Privacidade
                    </Link>.
                  </p>
                </div>
              </div>

              {/* 9. Legislação Aplicável */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-scales-line text-[#ff6b35]"></i>
                  9. Legislação Aplicável e Resolução de Conflitos
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-gray-700 mb-4">
                    Estes Termos e Condições são regidos pelas leis da República de Angola, incluindo:
                  </p>
                  <ul className="space-y-2 text-gray-700 mb-6">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Código Civil Angolano</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Lei de Defesa do Consumidor</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Lei de Proteção de Dados Pessoais</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                      <span>Regulamentação do setor de turismo e aviação civil</span>
                    </li>
                  </ul>
                  <p className="text-gray-700">
                    Qualquer litígio será resolvido preferencialmente por acordo amigável. Na impossibilidade, será submetido aos tribunais competentes de Luanda, Angola.
                  </p>
                </div>
              </div>

              {/* 10. Alterações aos Termos */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-refresh-line text-[#ff6b35]"></i>
                  10. Alterações aos Termos e Condições
                </h2>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-gray-700">
                    A FF TRAVEL reserva-se o direito de alterar estes Termos e Condições a qualquer momento. As alterações entrarão em vigor imediatamente após a sua publicação no website. Recomendamos que reveja regularmente esta página.
                  </p>
                </div>
              </div>

              {/* 11. Contacto */}
              <div className="mb-12">
                <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                  <i className="ri-mail-line text-[#ff6b35]"></i>
                  11. Contacto
                </h2>
                <div className="bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] rounded-xl p-8 text-white">
                  <p className="mb-6 text-lg">
                    Para questões sobre estes Termos e Condições, contacte-nos:
                  </p>
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <i className="ri-building-line text-2xl text-[#ff6b35]"></i>
                      <div>
                        <p className="font-semibold">FF Prestação & Serviço, Lda</p>
                        <p className="text-white/80 text-sm">NIF: 500714988</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className="ri-map-pin-line text-2xl text-[#ff6b35]"></i>
                      <p>Rua do Campo do Escoqueiro, de frente ao prédio do Cucu, Luanda, Angola</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className="ri-phone-line text-2xl text-[#ff6b35]"></i>
                      <div>
                        <a href="tel:+244936769113" className="hover:text-[#ff6b35] transition-colors cursor-pointer">+244 936 769 113</a>
                        <span className="mx-2">|</span>
                        <a href="tel:+244927606910" className="hover:text-[#ff6b35] transition-colors cursor-pointer">+244 927 606 910</a>
                        <span className="mx-2">|</span>
                        <a href="tel:+244925993120" className="hover:text-[#ff6b35] transition-colors cursor-pointer">+244 925 993 120</a>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <i className="ri-whatsapp-line text-2xl text-[#ff6b35]"></i>
                      <a 
                        href="https://wa.me/244936769113" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="hover:text-[#ff6b35] transition-colors cursor-pointer"
                      >
                        WhatsApp: +244 936 769 113
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Aceitação */}
              <div className="bg-teal-50 border-l-4 border-teal-600 rounded-lg p-8">
                <div className="flex items-start gap-4">
                  <i className="ri-information-line text-3xl text-teal-600 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold text-teal-900 mb-3">Aceitação dos Termos</h3>
                    <p className="text-teal-800 leading-relaxed">
                      Ao utilizar os serviços da FF TRAVEL, você declara ter lido, compreendido e aceite integralmente estes Termos e Condições Gerais, bem como a nossa Política de Privacidade.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-24 bg-gray-50">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">
              Tem Dúvidas sobre os Termos?
            </h2>
            <p className="text-xl text-gray-600 mb-10">
              A nossa equipa está disponível para esclarecer qualquer questão
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://wa.me/244936769113" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-[#ff6b35] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Falar no WhatsApp
              </a>
              <Link 
                to="/contactos"
                className="inline-block bg-[#1e40af] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#1e3a8a] transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Ver Contactos
              </Link>
            </div>
          </div>
        </section>

        {/* Rodapé */}
        <footer className="bg-black text-white py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
              <div>
                <img 
                  src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/e349152b587c7809cba7381685cd68b4.png" 
                  alt="Logótipo FF Travel Angola branco - Agência de Viagens" 
                  className="h-24 md:h-28 mb-8"
                />
                <p className="text-white/70 leading-relaxed mb-4">
                  FF Prestação & Serviço, Lda
                </p>
                <p className="text-white/50 text-sm">
                  NIF: 500714988
                </p>
              </div>

              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Contactos</p>
                <div className="space-y-3">
                  <a href="tel:+244936769113" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                    +244 936 769 113
                  </a>
                  <a href="tel:+244927606910" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                    +244 927 606 910
                  </a>
                  <a href="tel:+244925993120" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                    +244 925 993 120
                  </a>
                </div>
              </div>

              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Localização</p>
                <p className="text-white/70 leading-relaxed">
                  Rua do Campo do Escoqueiro<br />
                  De frente ao prédio do Cucu<br />
                  Luanda, Angola
                </p>
              </div>

              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Links Rápidos</p>
                <div className="space-y-3">
                  <Link to="/" className="block text-white hover:text-[#ff6b35] transition-colors">Início</Link>
                  <Link to="/agencia-viagens" className="block text-white hover:text-[#ff6b35] transition-colors">Agência de Viagens</Link>
                  <Link to="/loja-servicos" className="block text-white hover:text-[#ff6b35] transition-colors">Loja & Serviços</Link>
                  <Link to="/sobre" className="block text-white hover:text-[#ff6b35] transition-colors">Sobre</Link>
                  <Link to="/politicas-privacidade" className="block text-white hover:text-[#ff6b35] transition-colors">Políticas de Privacidade</Link>
                  <Link to="/termos-condicoes" className="block text-white hover:text-[#ff6b35] transition-colors">Termos e Condições</Link>
                </div>
              </div>
            </div>

            <div className="border-t border-white/10 pt-8">
              <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                <p className="text-white/50 text-sm">
                  © 2025 FF TRAVEL. Todos os direitos reservados.
                </p>
                <div className="flex items-center gap-6">
                  <Link to="/termos-condicoes" className="text-white/50 hover:text-white transition-colors text-sm">
                    Termos e Condições
                  </Link>
                  <Link to="/politicas-privacidade" className="text-white/50 hover:text-white transition-colors text-sm">
                    Políticas de Privacidade
                  </Link>
                  <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm">Web Design</a>
                </div>
              </div>
              
              {/* Desenvolvido por Snurf */}
              <div className="mt-6 text-center">
                <p className="text-white/40 text-xs">
                  Desenvolvido por <span className="text-white/60 font-semibold">Snurf</span>
                </p>
              </div>
            </div>
          </div>
        </footer>

        {/* Botão WhatsApp Flutuante */}
        <a 
          href="https://wa.me/244936769113" 
          target="_blank" 
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
          style={{ boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)' }}
        >
          <i className="ri-whatsapp-line text-3xl"></i>
        </a>
      </div>
    </>
  );
}
